'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$VerifyGoogleTokenRequest(token, tenantId) {
  this.a0Z = null;
  this.a0Y = null;
  this.a0Z = token;
  this.a0Y = tenantId;
}
export { $c_Lpresto_types$proto$VerifyGoogleTokenRequest as $c_Lpresto_types$proto$VerifyGoogleTokenRequest };
$p = $c_Lpresto_types$proto$VerifyGoogleTokenRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$VerifyGoogleTokenRequest;
/** @constructor */
function $h_Lpresto_types$proto$VerifyGoogleTokenRequest() {
}
export { $h_Lpresto_types$proto$VerifyGoogleTokenRequest as $h_Lpresto_types$proto$VerifyGoogleTokenRequest };
$h_Lpresto_types$proto$VerifyGoogleTokenRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$VerifyGoogleTokenRequest)) {
    if ((this.a0Z === x$0.a0Z)) {
      var x = this.a0Y;
      var x$2 = x$0.a0Y;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "VerifyGoogleTokenRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.a0Z;
  }
  if ((n === 1)) {
    return this.a0Y;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$VerifyGoogleTokenRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mm)));
}
export { $isArrayOf_Lpresto_types$proto$VerifyGoogleTokenRequest as $isArrayOf_Lpresto_types$proto$VerifyGoogleTokenRequest };
var $d_Lpresto_types$proto$VerifyGoogleTokenRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$VerifyGoogleTokenRequest, "presto.types$proto$VerifyGoogleTokenRequest", ({
  mm: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$VerifyGoogleTokenRequest as $d_Lpresto_types$proto$VerifyGoogleTokenRequest };
//# sourceMappingURL=presto.types$proto$-Verify-Google-Token-Request.js.map
